<ion-content class="no_padding" id="photo_gallery_filters" scroll-y="false">
    
    <form [formGroup]="this.filtersPhotoForm" (ngSubmit)="this.search()">
        <div class="title_card">{{'FILTER_PHOTOS' | translate}}</div>        
        <marv-tabs [tabs]="this.tabsFilters">
            <marv-tab tabId="all">
                <app-photo-gallery-filters-all 
                    #photoGalleryFiltersAll 
                    [operationsAll]="this.operationsAll" 
                    [photoFiltersValues]="this.photoFiltersValues" 
                    [hideFiltersStore]="this.hideFiltersStore" 
                    />
            </marv-tab>           
            <marv-tab tabId="anima">
                <app-photo-gallery-filters-anima 
                    #photoGalleryFiltersAnima
                    [operationsAll]="this.operationsAll" 
                    [photoFiltersValues]="this.photoFiltersValues" 
                    />
            </marv-tab>
            <marv-tab tabId="pearls">
                <app-photo-gallery-filters-pearls 
                    #photoGalleryFiltersPearls
                    [operationsAll]="this.operationsAll" 
                    [photoFiltersValues]="this.photoFiltersValues" 
                    />
            </marv-tab>
        </marv-tabs>

        <ion-grid id="footer_photo_gallery_filters">
            <ion-row class="ion-justify-content-around">
                <ion-col size="auto">
                    <marv-button type="submit" label="{{ 'SEARCH' | translate }}" icon="search-outline" color="primary" />
                </ion-col>
                <ion-col size="auto">
                    <marv-button type="button" label="{{ 'DISPLAY_ALL' | translate }}" icon="refresh-outline" color="secondary" (click)="this.displayAll()" />
                </ion-col>
            </ion-row>
        </ion-grid>
    
    </form>
        
</ion-content>